import { AskMode } from '@/entities/ask-syncly';
import { Tabs, TabsList, TabsTrigger } from '@/shared/components/shadcn/tabs';
import { TooltipFlat } from '@/shared/components/shadcn/tooltip/tooltip-flat';

export const ModeSelector = ({
  value,
  onChange,
}: {
  value: AskMode;
  onChange: (value: AskMode) => void;
}) => {
  return (
    <Tabs
      value={value}
      onValueChange={(value) => {
        onChange(value as AskMode);
      }}
    >
      <TabsList className="flex w-40 gap-2">
        <TooltipFlat asChild content="Research questions with detailed reports and analysis">
          <div className="flex flex-1">
            <TabsTrigger value={AskMode.GENERAL} className="flex-1">
              General
            </TabsTrigger>
          </div>
        </TooltipFlat>
        <TooltipFlat asChild content="Video questions with creative analysis and key insights">
          <div className="flex flex-1">
            <TabsTrigger value={AskMode.CONTENT} className="flex-1">
              Content
            </TabsTrigger>
          </div>
        </TooltipFlat>
      </TabsList>
    </Tabs>
  );
};
